<div>
  <mat-accordion multi>
    <mat-expansion-panel [expanded]="expanded">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Documents
        </mat-panel-title>
        <mat-panel-description class="">
          {{ panelDescription }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="row" *ngIf="hasDoc; else noDoc">
        <app-property-doc-card class="d-flex col-md-6 col-lg-4" *ngFor="let group of docGroups" [prop]="prop"
          [title]="docGroupTitles[group]" [docs]="docs[group]" (docUpdated)="loadDocList()"></app-property-doc-card>
      </div>
      <ng-template #noDoc>
        <span class="no-content dark">Aucun document n'est disponible dans cette catégorie</span>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
